<div class="wrapper">
	<app-generic-table-header [config]="headerOptions" (refreshEvent)="refreshTable($event)"></app-generic-table-header>
	
	<ng-template #affixTemplate let-row>
		@if (
			(row.KeepAliveAccess || row.CDRAccess || row.MikrotikAccess || row.RelayAccess) &&
			row.Revoked !== true &&
			row.ID == currentGroup &&
			row.ID != currentDefaultGroup
		) {
			<app-card-table-actions [row]="row" [actions]="notDefaultActive" (actionEvent)="onGroupAction($event)"
				[breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
		}
		@if (
			(row.KeepAliveAccess || row.CDRAccess || row.MikrotikAccess || row.RelayAccess) &&
			row.Revoked !== true &&
			row.ID == currentGroup &&
			row.ID == currentDefaultGroup
		) {
			<app-card-table-actions [row]="row" [actions]="defaultActive"
				[breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
		}
		@if (
			(row.KeepAliveAccess || row.CDRAccess || row.MikrotikAccess || row.RelayAccess) &&
			row.Revoked !== true &&
			row.ID != currentGroup &&
			row.ID == currentDefaultGroup
		) {
			<app-card-table-actions [row]="row" [actions]="defaultNotActive" (actionEvent)="onGroupAction($event)"
				[breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
		}
		@if (
			(row.KeepAliveAccess || row.CDRAccess || row.MikrotikAccess || row.RelayAccess) &&
			row.Revoked !== true &&
			row.ID != currentGroup &&
			row.ID != currentDefaultGroup
		) {
			<app-card-table-actions [row]="row" [actions]="notDefaultNotActive" (actionEvent)="onGroupAction($event)"
				[breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
		}
		<!-- <app-card-table-actions 
	*ngIf="(row.KeepAliveAccess || row.CDRAccess || row.MikrotikAccess || row.RelayAccess) && groups.length >= 1  && row.Revoked !== true && row.ID != currentGroup"
		[row]="row" [actions]="groupRowActions" (onAction)="onGroupAction($event)"
		[breakpoint]='ScreenSize.TABLET'></app-card-table-actions> -->
		<!-- Change Session -->
		<!-- Current Group -->
	</ng-template>

	@if (loading) {
		<div class="mauto">
			<mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
		</div>
	}

	@if (groups != null && groups.length > 0) {
		<app-card-table #GroupTable [tableHeaders]="headers" [currentPage]="currentGroupPage" [data]="groups"
			[totalItems]="totalGroups" [options]="groupTableOptions" [enableInfiteScroll]="false" [enableTablePagination]="true"
			(paginateEvent)="getPagedGroups($event)" [affixTemplate]="affixTemplate" [breakpoint]="ScreenSize.TABLET"
			[enableRefresher]="false">
		</app-card-table>
	}
	<button mat-raised-button color="cancel" class="cancel-button" (click)="goBack()">Cancel</button>
</div>